import { render, staticRenderFns } from "./centerHome.vue?vue&type=template&id=2a3d8ea0"
import script from "./centerHome.vue?vue&type=script&lang=js"
export * from "./centerHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports